import * as React from "react";
export class Arrow extends React.PureComponent {
    constructor(props) {
        super(props);
        this.baseClass = "rj-arrow";
        this.holderClass = `${this.baseClass}__holder`;
    }
    render() {
        const fullClass = this.holderClass + (this.props.direction ?
            ` ${this.holderClass}--${this.props.direction}` :
            "");
        return (React.createElement("span", { className: this.baseClass },
            React.createElement("span", { className: fullClass })));
    }
}
//# sourceMappingURL=Arrow.js.map